var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg09N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_645)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.127,
    y: 19.5445,
    width: 1.76471,
    height: 5.87295,
    rx: 0.882353,
    transform: "rotate(-30 20.127 19.5445)",
    fill: "url(#paint0_linear_10214_645)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_10214_645)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.0657,
    y: 19.1497,
    width: 1.76471,
    height: 7.06637,
    rx: 0.882353,
    transform: "rotate(-30 17.0657 19.1497)",
    fill: "url(#paint1_linear_10214_645)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_10214_645)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.7874,
    y: 20.0232,
    width: 1.76471,
    height: 6.58681,
    rx: 0.882353,
    transform: "rotate(-30 11.7874 20.0232)",
    fill: "url(#paint2_linear_10214_645)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_10214_645)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.6091,
    y: 19.7685,
    width: 1.76471,
    height: 5.85646,
    rx: 0.882353,
    transform: "rotate(-30 14.6091 19.7685)",
    fill: "url(#paint3_linear_10214_645)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_10214_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.555H10.186C7.60386 22.555 6.11768 20.9028 6.11768 18.8603C6.11768 17.0918 7.23854 15.6969 8.89909 15.2237C9.18969 11.9109 11.913 9.41177 15.1344 9.41177C17.6004 9.41177 19.6262 10.7485 20.7305 12.9404C23.7444 12.9404 25.9612 14.9995 25.9612 17.7311C25.9612 20.4378 23.7942 22.555 20.9962 22.555Z",
    fill: "url(#paint4_linear_10214_645)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3956 13.1092L20.4995 13.3154H20.7305C23.5674 13.3154 25.5862 15.2355 25.5862 17.7311C25.5862 20.2212 23.5967 22.18 20.9962 22.18H10.186C8.97676 22.18 8.05784 21.7947 7.44361 21.2034C6.82895 20.6117 6.49268 19.7886 6.49268 18.8603C6.49268 17.2675 7.49448 16.0139 9.00187 15.5843L9.2501 15.5136L9.27266 15.2565C9.54664 12.1331 12.1116 9.78677 15.1344 9.78677C17.4494 9.78677 19.3507 11.0352 20.3956 13.1092Z",
    stroke: "url(#paint5_linear_10214_645)",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_645",
    x: 7.14444,
    y: 5.67966,
    width: 30.4296,
    height: 31.9334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_10214_645",
    x: 4.08316,
    y: 5.28488,
    width: 31.0265,
    height: 32.9669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_10214_645",
    x: -1.19516,
    y: 6.15836,
    width: 30.7866,
    height: 32.5516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_10214_645",
    x: 1.62662,
    y: 5.90369,
    width: 30.4216,
    height: 31.9191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_10214_645",
    x: -13.8823,
    y: -10.5882,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_645",
    x1: 20.636,
    y1: 20.8292,
    x2: 22.1342,
    y2: 20.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_645",
    x1: 17.5747,
    y1: 20.6955,
    x2: 19.0778,
    y2: 20.8245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10214_645",
    x1: 12.2964,
    y1: 21.464,
    x2: 13.7978,
    y2: 21.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10214_645",
    x1: 15.1182,
    y1: 21.0496,
    x2: 16.6163,
    y2: 21.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10214_645",
    x1: 16.0394,
    y1: 9.41177,
    x2: 26,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0350391,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10214_645",
    x1: 6.11768,
    y1: 9.41177,
    x2: 26,
    y2: 22.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645504,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09N);
export default __webpack_public_path__ + "static/media/09n.a3a5cfe0c81bead1735635cc0a00bb02.svg";
export { ForwardRef as ReactComponent };